// extracted by mini-css-extract-plugin
export default {"root":"W1r_9e"};